import React from 'react';

const MeasurementUnitsHeader = () => {
    return (
        <h1>Measurement Units</h1>
    );
};

export default MeasurementUnitsHeader;
